export const CHECKOUT_URL = 'https://colorpack.store/cart/52028397748522:1'

export const IMAGES = {
  logo: 'https://cdn.magicpatterns.com/uploads/8hyr32okVRhVt4rzU4ZFgb/Imagen.png',
  bono1:
    'https://cdn.magicpatterns.com/uploads/294pvkn95tg4kE6GSQwEzX/protocolo_b1.webp',
  bono2:
    'https://cdn.magicpatterns.com/uploads/8dGYiH9peu6FVPv7kxz2sx/protocolo_b2.webp',
  bono3:
    'https://cdn.magicpatterns.com/uploads/oMUHKAf83XeFVhqin8WtMv/protocolo_b3.webp',
  bono4:
    'https://cdn.magicpatterns.com/uploads/uv2vjnup7MKLKVYNQR9kct/protocolo_b4.webp',
  bono5:
    'https://cdn.magicpatterns.com/uploads/kk1qRoUdYSaJFD2PGoUw8j/protocolo_b5.webp',
  bono6:
    'https://cdn.magicpatterns.com/uploads/2Tw8977c46kSMtrumVhCYC/protocolo_b6.webp',
  bono7:
    'https://cdn.magicpatterns.com/uploads/ub1QjSsi2fDC62aenPnwLG/protocolo_b7.webp',
  principal:
    'https://cdn.magicpatterns.com/uploads/dx2fuxcbtToUC66TG7Syo3/protocolo_principal.webp',
}

/** Redirects the buyer to the Shopify checkout. No manual Meta events fired here. */
export function goToCheckout(): void {
  window.location.href = CHECKOUT_URL
}
